// ** Auth Endpoints
export default {
  loginEndpoint: 'https://apiv3dev.opentlv.com/api/v1/authenticateUI',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: 'https://apiv3dev.opentlv.com/api/v1/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
